var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpdates(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72.08 62.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    "data-name": "Layer 62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.13 15.15h33.56M29.13 32.09h33.56M29.13 47.06h33.56M9.4 11.86h6.58v6.58H9.4zm0 16.45h6.58v6.58H9.4zm0 15.46h6.58v6.58H9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 1.5h69.08v59.21H1.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdates);
export default __webpack_public_path__ + "static/media/updates.ab10186adf70e00292a718b9156b5e8a.svg";
export { ForwardRef as ReactComponent };